import { Link } from "react-router-dom";
import { BUSINESS } from "@/data/content";

// Text-based wordmark matching the logo (serif + script)
export default function Wordmark({ dark = false, className = "", compact = false }) {
  const color = dark ? "text-white" : "text-[#050505]";
  return (
    <Link
      to="/"
      data-testid="brand-wordmark"
      className={`group inline-flex flex-col items-center leading-none ${className}`}
      aria-label={BUSINESS.name}
    >
      <span
        className={`font-serif-display uppercase ${color} ${
          compact ? "text-2xl md:text-3xl" : "text-3xl md:text-4xl"
        }`}
        style={{ letterSpacing: "0.3em", paddingLeft: "0.3em", fontWeight: 600 }}
      >
        Barrhaven
      </span>
      <span
        className={`font-body uppercase ${color} ${compact ? "text-[11px] md:text-xs mt-1" : "text-xs md:text-sm mt-1.5"}`}
        style={{ letterSpacing: "0.44em", paddingLeft: "0.44em", fontWeight: 500 }}
      >
        Beauty Lounge
      </span>
    </Link>
  );
}
